// extracted by mini-css-extract-plugin
module.exports = {"videoBlock":"VideoBlock_videoBlock__hzBUy","videoTitle":"VideoBlock_videoTitle__REdH2"};